<template>
  <div class="pr-md-24 mt-5">
    <div>
      <div class="d-flex justify-end mb-2">
        <v-btn
          tile
          color="primary"
          @click="$router.push({ name: 'admin-index' })"
        >
          <v-icon left>
            arrow_back
          </v-icon>
          Back
        </v-btn>
      </div>
      <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
        <v-form
          v-model="valid"
          ref="form"
          lazy-validation
          class="pa-4 px-4"
          @submit.prevent="editAdmin"
          v-if="user"
        >
          <div class="mt-2">
            <v-row>
              <v-col md="6" cols="12">
                <image-picker
                  v-model="user.avatar"
                  :add="user.avatar === null"
                  :uploaded="user.avatar !== null"
                  @delete-item="user.avatar = null"
                  @reset="user.avatar = null"
                  class="mb-5"
                >
                  <div slot="activator" class="cursor-pointer w-100 h-100">
                    <img
                      :src="user.avatar"
                      alt="avatar"
                      height="100%"
                      v-if="user.avatar"
                    />
                  </div>
                </image-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  :counter="35"
                  label="Email"
                  v-model="user.email"
                  :rules="emailRules"
                  outlined
                ></v-text-field>

                <v-text-field
                  :counter="35"
                  label="First Name"
                  v-model="user.firstName"
                  :rules="nameRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  :counter="20"
                  label="Last Name"
                  v-model="user.lastName"
                  :rules="nameRules"
                  outlined
                  required
                ></v-text-field>
              </v-col>

              <v-col>
                <v-tel-field
                  :counter="35"
                  label="Phone"
                  type="number"
                  v-model="user.phone"
                  outlined
                  name="phone"
                  :rules="phoneRules"
                ></v-tel-field>

                <v-text-field
                  :counter="35"
                  label="Password"
                  outlined
                  v-model="user.password"
                  name="password"
                  :rules="passwordRules"
                  type="password"
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="text-left">
              <v-btn type="submit" color="accent" class="white--text mx-0"
                >Update</v-btn
              >
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  props: ["id"],
  data() {
    return {
      valid: false,
      types: ["employee", "owner"],
      roles: ["admin", "user"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than than 15 characters"
      ],
      gdcRules: [
        v => !!v || "GdcNumber is required",
        v => v.length >= 8 || "Phone must be at least 8 digits",
        v => v.length <= 20 || "Phone must be less than than 20 digits"
      ],
      typeRules: [v => !!v || "Type is required"],
      roleRules: [v => !!v || "Role is required"]
    };
  },
  components: {
    ImagePicker
  },
  async mounted() {
    await this.$store.dispatch("users/LOAD_USER_POSITIONS");
    await this.$store.dispatch("admins/LOAD_ADMIN", {
      userId: this.id
    });
  },
  computed: {
    ...mapState({
      user: state => state.admins.user,
      userPositions: state => state.users.user_positions
    })
  },
  methods: {
    async editAdmin() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating admin...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("admins/UPDATE_ADMIN", this.user);
      }
    }
  }
};
</script>
